import angular from "angular";
import {
    REMOTE_CONSOLE_GUI_V2,
    REMOTE_CONSOLE_CLASSIC
} from "@/constants/installations";

(function() {
    angular
        .module("vrm.core")
        .controller(
            "RemoteConsoleEmbeddedController",
            RemoteConsoleEmbeddedController
        );

    /**
     * @constructor
     * @ngInject
     */
    function RemoteConsoleEmbeddedController(
        $scope,
        $state,
        $rootScope,
        InstallationsService,
        $stateParams,
        RemoteConsole2Service,
        VrmModalService,
        vrmNotificationsService,
        vrmNotificationType,
        locale,
        $timeout
    ) {
        $scope.installation = null;
        $scope.showChoiceScreen = false;
        $scope.showV2Console = false;
        $scope.showClassicConsole = false;
        $scope.$stateParams = $stateParams;

        let cleanupErrorHandling = null;
        let choiceSelectedHandler = null;

        function init() {
            cleanupErrorHandling = RemoteConsole2Service.setupErrorHandling();

            $rootScope.remoteConsoleEmbeddedMode = true;

            if (!$rootScope.userState) {
                $rootScope.userState = {
                    isDemo: false,
                    isShare: false,
                    isAdmin: false,
                    isFullAdmin: false,
                    isRestrictedAdmin: false
                };
            }

            InstallationsService.getInstallation($stateParams.id)
                .then(installation => {
                    $scope.installation = installation;

                    const existingChoice = installation.remoteConsoleChoice;
                    const hasOldGui =
                        installation.view_permissions.rc_classic &&
                        installation.GUIv !== 2;
                    const hasNewGui = installation.view_permissions.rc_gui_v2;

                    if (!existingChoice && (hasOldGui || hasNewGui)) {
                        $scope.showChoiceScreen = true;
                    } else if (
                        hasNewGui &&
                        existingChoice === REMOTE_CONSOLE_GUI_V2
                    ) {
                        openV2Console();
                    } else if (
                        hasOldGui &&
                        existingChoice === REMOTE_CONSOLE_CLASSIC
                    ) {
                        openClassicConsole();
                    } else if (hasNewGui && !hasOldGui) {
                        openV2Console();
                    } else if (hasOldGui && !hasNewGui) {
                        openClassicConsole();
                    } else {
                        showNoAccessError();
                    }
                })
                .catch(error => {
                    console.error(
                        "RemoteConsoleEmbeddedController: Error getting installation",
                        error
                    );
                });
        }

        $scope.onChoiceSelected = function(choice) {
            $scope.showChoiceScreen = false;

            if (choice === REMOTE_CONSOLE_GUI_V2) {
                openV2Console();
            } else if (choice === REMOTE_CONSOLE_CLASSIC) {
                openClassicConsole();
            }
        };

        function openV2Console() {
            $scope.showV2Console = true;
            $scope.showChoiceScreen = false;
            $scope.showClassicConsole = false;

            if (!$scope.$$phase) {
                $scope.$apply();
            }

            $timeout(function() {
                RemoteConsole2Service.addBodyClass();
                const {
                    isMobile,
                    isTablet
                } = RemoteConsole2Service.setupMobileDetection();

                if (
                    !RemoteConsole2Service.validatePermissions(
                        $scope.installation,
                        $state,
                        $stateParams,
                        true
                    )
                ) {
                    return;
                }

                const eventListeners = RemoteConsole2Service.setupEventListeners(
                    isMobile,
                    isTablet
                );

                RemoteConsole2Service.loadRemoteConsole(
                    $scope.installation,
                    $stateParams,
                    true,
                    false
                );

                $scope.$on("$destroy", function() {
                    RemoteConsole2Service.removeBodyClass();
                    eventListeners.cleanup();
                });
            }, 0);
        }

        function openClassicConsole() {
            $scope.showClassicConsole = true;
            $scope.showChoiceScreen = false;
            $scope.showV2Console = false;

            VrmModalService.openRemoteConsoleModal(
                $scope,
                $scope.installation,
                {
                    embedded: true,
                    onClose: () => {
                        $scope.showChoiceScreen = true;
                        $scope.showClassicConsole = false;
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                }
            );
        }

        function showNoAccessError() {
            locale.ready("core").then(function() {
                vrmNotificationsService.add({
                    type: vrmNotificationType.ERROR,
                    message:
                        locale.getString("core.not_supporting_new_rc") ||
                        "Remote console is not available for this installation"
                });
            });
            $state.go("base.installation.dashboard", { id: $stateParams.id });
        }

        $scope.$on("$destroy", function() {
            $rootScope.remoteConsoleEmbeddedMode = false;

            if (cleanupErrorHandling) {
                cleanupErrorHandling();
            }

            if (choiceSelectedHandler) {
                window.removeEventListener("remote-console-choice-selected", choiceSelectedHandler);
            }
        });

        init();

        choiceSelectedHandler = function(event) {
            $scope.onChoiceSelected(event.detail);
        };
        window.addEventListener("remote-console-choice-selected", choiceSelectedHandler);
    }
})();
